"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPastEventService = void 0;
var tsyringe_1 = require("tsyringe");
var contractsService_1 = require("../contractService/contractsService");
var configurationService_1 = require("../configurationService/configurationService");
var arianeeHttpClient_1 = require("../../../libs/arianeeHttpClient/arianeeHttpClient");
var append_query_1 = __importDefault(require("append-query"));
var web3Service_1 = require("../web3Service/web3Service");
var utilsService_1 = require("../utilService/utilsService");
var GetPastEventService = /** @class */ (function () {
    function GetPastEventService(contractService, arianeeHttpClient, configurationService, web3Service, utils) {
        var _this = this;
        this.contractService = contractService;
        this.arianeeHttpClient = arianeeHttpClient;
        this.configurationService = configurationService;
        this.web3Service = web3Service;
        this.utils = utils;
        this.urlFactory = function (contractAddress, eventName, parameters) {
            if (parameters === void 0) { parameters = {}; }
            if (!_this.web3Service.web3.utils.isAddress(contractAddress)) {
                throw new Error('contractAddress must be a valid address');
            }
            var toBlock = parameters.toBlock, fromBlock = parameters.fromBlock;
            var endpoint = _this.configurationService.getBlockChainProxyEndpoint();
            var chainId = _this.configurationService.arianeeConfiguration.chainId;
            var filter = parameters.filter || [];
            var returnValues = Object.keys(filter).reduce(function (acc, curr, index) {
                acc["returnValues.".concat(curr)] = filter[curr];
                return acc;
            }, {});
            var url = "".concat(endpoint, "/").concat(chainId, "/contract/").concat(contractAddress, "/").concat(eventName);
            var finalUrl = (0, append_query_1.default)(url, __assign(__assign({}, returnValues), { toBlock: toBlock, fromBlock: fromBlock }));
            return finalUrl;
        };
        this.getPastEvents = function (contractAddressOrContractName, eventName, parameters) { return __awaiter(_this, void 0, void 0, function () {
            var contractInstance, address, url, result, events;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contractInstance = this.contractService.getInstanceFromAddressOrName(contractAddressOrContractName);
                        if (!contractInstance) {
                            throw new Error("this contract does not exist ".concat(contractAddressOrContractName));
                        }
                        address = contractInstance.options.address;
                        if (!this.configurationService.isProxyEnable()) return [3 /*break*/, 2];
                        url = this.urlFactory(address, eventName, parameters);
                        return [4 /*yield*/, this.arianeeHttpClient.fetch(url)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                    case 2: return [4 /*yield*/, contractInstance
                            .getPastEvents(eventName, parameters)];
                    case 3:
                        events = _a.sent();
                        return [2 /*return*/, Promise.all(events.map(function (bcEvent) { return __awaiter(_this, void 0, void 0, function () {
                                var timestamp;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.utils.getTimestampFromBlock(bcEvent.blockNumber)];
                                        case 1:
                                            timestamp = _a.sent();
                                            return [2 /*return*/, __assign(__assign({}, bcEvent), { timestamp: timestamp })];
                                    }
                                });
                            }); }))];
                }
            });
        }); };
    }
    GetPastEventService = __decorate([
        (0, tsyringe_1.injectable)(),
        __metadata("design:paramtypes", [contractsService_1.ContractService,
            arianeeHttpClient_1.ArianeeHttpClient,
            configurationService_1.ConfigurationService,
            web3Service_1.Web3Service,
            utilsService_1.UtilsService])
    ], GetPastEventService);
    return GetPastEventService;
}());
exports.GetPastEventService = GetPastEventService;
//# sourceMappingURL=getPastEventService.js.map